export enum ScenarioItemSubType {
  SHORT_ANSWER = 'short-answer',
  MULTI_CHOICE = 'multi-choice',
  LINEAR_SCALE = 'linear',
  POLL = 'poll',
  MS_TEAMS = 'ms-teams',
  CHIME = 'chime',
  ZOOM = 'zoom',
  GOOGLE_MEETS = 'google-meets',
  QUESTION = 'question',
}
